import { RouterProvider } from '@tanstack/react-router';
import router from 'src/router-config';
import { ThemeProvider } from 'src/utils/theme';
import VersionModal from 'src/components/ui/VersionModal';
import { ToastNotifications } from 'src/utils/notifications';

const App = () => {
  const isMissingVersion = !import.meta.env.VITE_BUILD_VERSION;
  const buildVersion = (import.meta.env.VITE_BUILD_VERSION || '').trim();

  return (
    <ThemeProvider>
      {!isMissingVersion && <VersionModal buildVersion={buildVersion} />}
      <RouterProvider router={router} />
      <ToastNotifications />
    </ThemeProvider>
  );
};

export default App;
